import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid, Select } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateModel } from "../modelsThunks";
import { setSelectedModel, setIsEditModel } from "../modelsSlice";
import { getAccessType } from "../../../lib/functions";
import { fetchItemCategories } from "../../Product_manage/itemManageThunks";

const { Title } = Typography;
const { useBreakpoint } = Grid;
const { Option } = Select;

const CreateModelsForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const screens = useBreakpoint();

  const { isEditModel, selectedModel } = useSelector((state) => state.models);

  // 👈 adjust slice key if categories live elsewhere for this page
  const { categories } = useSelector((state) => state.itemManage);

  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("model_manage");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchItemCategories());
  }, [dispatch]);

  useEffect(() => {
    if (isEditModel && selectedModel) {
      form.setFieldsValue(selectedModel);
    } else {
      form.resetFields();
    }
  }, [isEditModel, selectedModel]);

  const handleCancel = () => {
    dispatch(setSelectedModel(null));
    dispatch(setIsEditModel(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    if (!values.category_id) {
      return modal.warning({ title: "Please select a Category" });
    }

    try {
      await dispatch(
        createOrUpdateModel({
          ...values,
          action: isEditModel ? "update" : "create",
          model_id: selectedModel?.model_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditModel
          ? "Model updated successfully"
          : "Model created successfully",
      });

      dispatch(setSelectedModel(null));
      dispatch(setIsEditModel(false));
      navigate("/inventory/models-manage");
    } catch (err) {
      modal.error({ title: err.message || "Save failed" });
    }
  };

  return (
    <div className="model-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEditModel ? "Update Model" : "Create New Model"}
      </Title>
      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Category"
              name="category_id"
              rules={[{ required: true, message: "Please select a category" }]}
            >
              <Select placeholder="Select Category" data-testid="category-select">
                {categories?.map((c) => (
                  <Option key={c.category_id} value={c.category_id}>
                    {c.category_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Model Name"
              name="model_name"
              rules={[
                { required: true, message: "Please enter model name" },
              ]}
            >
              <InputField placeholder="Enter Model Name" />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button size="large" onClick={handleCancel} className="traic-button">
            Back
          </Button>

          {access_type == "WRITE" && <>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="traic-button"
            >
              {isEditModel ? "Update" : "Save"}
            </Button></>}

        </Flex>
      </Form>
    </div>
  );
};

export default CreateModelsForm;